import { NumberInput, required } from "react-admin";

const TestFingridAfrrInitialFields = () => {
  return (
    <>
      <NumberInput source={"afrr_capacity"} defaultValue={2.5} validate={[required()]} />
      <NumberInput source={"baseline_power"} defaultValue={1.25} validate={[required()]} />
    </>
  );
};

export default TestFingridAfrrInitialFields;
